import { InfoCircleOutlined } from '@ant-design/icons';
import { Form, Modal, Radio } from '@maxtropy/components';
import { apiV2PvStationUpsetIncomeCalculateWayPost } from '@maxtropy/dmes-apis-v2';
import { useRequest } from 'ahooks';
import { Col, Row, Space } from 'antd';
import { useEffect } from 'react';
import styles from './index.module.scss';

export enum CalculateWay {
  ORIGIN = 1,
  TRANSFORM = 2,
}
export const CalculateWayDisplay = {
  [CalculateWay.ORIGIN]: '尖峰平谷数据',
  [CalculateWay.TRANSFORM]: '正向有功电能',
};

interface Iprops {
  onCancel?: () => void;
  onConfirm?: () => void;
  mode?: CalculateWay;
  pvStationId?: number;
}
const ModeModal = ({ onCancel, onConfirm, mode, pvStationId }: Iprops) => {
  const [form] = Form.useForm();
  const incomeCalculateWay = Form.useWatch('incomeCalculateWay', form);
  const { runAsync, loading } = useRequest(params => apiV2PvStationUpsetIncomeCalculateWayPost(params), {
    manual: true,
  });
  const confirmBtn = () => {
    if (!pvStationId) return;
    runAsync({
      pvStationId,
      incomeCalculateWay,
    }).then(res => {
      onConfirm?.();
    });
  };

  useEffect(() => {
    if (mode) {
      form.setFieldsValue({
        incomeCalculateWay: mode,
      });
    }
  }, [mode]);
  return (
    <Modal
      open
      title="并网点电量来源设置"
      contentClassName="modal-form-content"
      confirmLoading={loading}
      onOk={() => confirmBtn()}
      onCancel={() => onCancel?.()}
    >
      <Form
        form={form}
        initialValues={{
          incomeCalculateWay: CalculateWay.ORIGIN,
        }}
        isOrigin
      >
        <Row>
          <Col span={24}>
            <Form.Item
              name="incomeCalculateWay"
              extra={
                <div style={{ marginTop: 8 }}>
                  <Space align="start">
                    <InfoCircleOutlined style={{ color: 'var(--warning-color)' }} />
                    <span>
                      模式切换后未来收益将按新模式进行计算，历史收益将不做处理，请确认光伏站实际情况后谨慎操作！
                    </span>
                  </Space>
                </div>
              }
            >
              <Radio.Group>
                <Space direction="vertical" size={0}>
                  <Radio value={CalculateWay.ORIGIN}>尖峰平谷数据</Radio>
                  <div className={styles.modalTip}>选择后将采用原始尖峰平谷数据计算并网点电量和收益</div>
                  <Radio value={CalculateWay.TRANSFORM}>正向有功电能</Radio>
                  <div className={styles.modalTip}>
                    选择后将对原始正向有功电能进行分时电能转换，计算并网点电量和收益
                  </div>
                </Space>
              </Radio.Group>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};
export default ModeModal;
